import { LETTERS, pad } from "../../qa";
import OptionButton from "../OptionButton/OptionButton";
import VerificationStatus from "../VerificationStatus/VerificationStatus";
import NotePanel from "../NotePanel/NotePanel";
import styles from "./QuestionCard.module.css";

export default function QuestionCard({
  question,
  pick,
  status,
  team,
  showKey,
  focused,
  reviewer,
  onPick,
  onClear,
  onComment,
  onSuggest,
  onDeleteNote,
}) {
  const locked = pick !== undefined;

  function optionState(i) {
    if (!locked) return "idle";
    if (i === pick) return status === "correct" ? "correct" : "wrong";
    if (i === question.answerIndex) return "expected";
    return "idle";
  }

  return (
    <article
      id={`q-${question.id}`}
      className={`${styles.card} ${focused ? styles.focused : ""}`}
      aria-labelledby={`h-${question.id}`}
    >
      <header className={styles.head}>
        <h3 id={`h-${question.id}`} className={styles.number}>
          Question {pad(question.index)}
        </h3>
        <span className={styles.diff}>{question.difficulty}</span>
        <span className={styles.points}>{question.points} PT</span>
      </header>
      <p className={styles.text}>{question.text}</p>
      <div className={styles.options}>
        {question.options.map((option, i) => (
          <OptionButton
            key={option}
            letter={LETTERS[i]}
            text={option}
            state={optionState(i)}
            locked={locked}
            onClick={() => onPick(question.id, i)}
          />
        ))}
      </div>
      <VerificationStatus question={question} status={status} showKey={showKey} />
      <div className={styles.team}>
        <span>Team / {team.hits + team.misses} checked</span>
        <span>{team.misses} miss</span>
        <span>{team.notes.length} notes</span>
        {locked && (
          <button type="button" className={styles.clear} onClick={() => onClear(question.id)}>
            Clear my check
          </button>
        )}
      </div>
      <NotePanel
        question={question}
        notes={team.notes}
        reviewer={reviewer}
        onComment={onComment}
        onSuggest={onSuggest}
        onDelete={onDeleteNote}
      />
    </article>
  );
}
